interface IOrderDetails {
  order_id: string;
  state: string;
  county_fips: string;
  transaction_type: string;
}

export class OrderDetails implements IOrderDetails {
  public order_id: string;
  public state: string;
  public county_fips: string;
  public transaction_type: string;

  constructor(
    { order_id, county_fips, state, transaction_type } = {
      county_fips: '',
      order_id: '',
      state: '',
      transaction_type: '',
    }
  ) {
    this.order_id = order_id;
    this.county_fips = county_fips;
    this.state = state;
    this.transaction_type = transaction_type;
  }
}
